$(document).ready(function() {
    if ($('.filter-sidebar').length > 0) {
        $('.filter-sidebar__taxonomy-title').on('click', function() {
            $(this).toggleClass('active');
            $('.tax-' + $(this).attr('data-target')).slideToggle();
        });

        // Fetch initial posts without filters
        doFilter();

        // Posts Search field
        $('#search-field').on('keyup', function (e) {
            if (e.keyCode === 13) {
                doSearch();
            }
        });

        $('.btn-search').on('click', function() {
            doSearch();
        });

        $('.btn-apply-filter').on('click', function() {
            doFilter();
        });

        // Pagination
        $('.button-load-more').on('click', function () {
            var paged = parseInt($('#paged').val()) + 1;
            $('#paged').val(paged);
 
            // Load more Blog Resources
            doFilter();
        });

        // Clear Filters
        $('.button__clear-all').on('click', function () {
            // Remove current content
            $('.archive-resources__content').empty();
            $('.tags-filtered').empty();

            clearFilterTerms();
            $('#search-field').val('');
            $('#paged').val(1);
            $(this).css('display', 'none');

            // Reset resources results
            doFilter();
        });
    }
});

function doFilter() {

	// Scroll to top to avoid staying at the bottom
	/*$('html, body').animate({
		scrollTop: $('.archive-resources__listing').offset().top
	}, 800);*/

	// Show loading
    $('.spinner').addClass('loading');
    
    // If we are pulling first page, remove all previous posts
    if ($('#paged').val() == 1) 
        $('.results-container__posts').empty();

	// Hide pagination
    $('.button-load-more').css('display', 'none');
    
    // Check if we are hiding filters and filtering for a custom tax
    if ($('#custom_tax_key').val() != '') {
        var terms = {};
        terms[$('#custom_tax_key').val()] = $('#custom_tax_value').val();
    } else {
        $('.tags-filtered').empty(); // Clear old filter terms
        var terms = getFilterTerms(); // Get Terms
    }

    // Show clear all if there are filters
    if (Object.keys(terms).length > 0) {
        $('.button__clear-all').css('display', 'flex');
        $('.results-found-text').html('Results found for:');
    } else {
        $('.results-found-text').html('Results found');
    }

    var date_range = getDateRange();
    var orderby = getOrderBy();

	// AJAX call
	$.ajax({
		url: ajax_var.url,
		method: 'POST',
		data: {
            action: $('#action').val(),
            post_type: $('#post_type').val(),
            terms: terms,
            date_from: date_range[0],
            date_to: date_range[1],
            orderby: orderby,
			search: $('#search-field').val(),
			paged: $('#paged').val(),
		}, success: function (response) {
			if (response && response.success) {
				// Add new content
				if (response.data.count > 0) {
                    $('.results-found-qty').html(response.data.count);
					$('.results-container__posts').append(response.data.html);
                } else {
                    $('.results-found-text').html('No results found');
                    $('.results-found-qty').html('');
                }

				// Hide loading
				$('.spinner').removeClass('loading');

                // Check if I need to show again the pagination
				if (response.data.see_more)
					$('.button-load-more').css('display', 'block');
			}
		}, error: function (error) {
			console.log(error);

			// Hide loading
			$('.spinner').removeClass('loading');
		}
	});

}

function getFilterTerms() {
    var terms = {};
    $('ul.terms').each(function() {
        $('.checkbox-terms', this).each(function() {
            if ($(this).is(':checked')) {
                if ($(this).attr('data-tax') in terms == false) 
                    terms[$(this).attr('data-tax')] = [];
                
                terms[$(this).attr('data-tax')][terms[$(this).attr('data-tax')].length] = $(this).val();

                $('.tags-filtered').append('<a href="javascript:void(0);" data-tax="' + $(this).attr('data-tax') + '" data-value="' + $(this).val() + '" title="' + $(this).attr('data-name') + '" class="tag-button tag-button-' + $(this).attr('data-tax') + '-' + $(this).val() + '"><span class="button-text">' + $(this).attr('data-name') + '</span><img src="/wp-content/themes/dma/images/icon-close.png"></a>');
            }
        });
    });

    $('.tags-filtered').on('click', '.tag-button', function() {
        var tax = $(this).data('tax');
        var value = $(this).data('value');
        removeFilter(tax, value);
    });

    return terms;
}

function clearFilterTerms() {
    $('.checkbox-terms').prop('checked', false);
}

function doSearch() {
    $('#paged').val('1');
    doFilter();
}

function removeFilter(tax, term) {
    console.log('.tag-button-' + tax + '-' + term);
    console.log($('.tag-button-' + tax + '-' + term));
    $('.tag-button-' + tax + '-' + term).remove();
    $('.checkbox-terms').each(function() {
        if ($(this).attr('data-tax') == tax && $(this).val() == term)
            $(this).prop('checked', false);
    });
    doFilter();
}

function getDateRange() {
    var dates_range = ["", ""];
    if ($('#filter-date-from').val() != '' && $('#filter-date-from').val() != '') {
        dates_range[0] = $('#filter-date-from').val();
        dates_range[1] = $('#filter-date-to').val();
    }
    return dates_range;
}

function getOrderBy() {
    return ($('input[name=sort]').length > 0) ? $('input[name=sort]:checked').val() : 'latest';
}